import { wtClientApi } from 'api/clients';

import type { GenericResponse } from 'commons/modules/generic-response';

import {
  ApiResponse,
  adaptApiToGenericResponse,
  adaptErrorToGenericResponse,
} from '../shared';

import type { CatalogClientDto } from './dto';
import { mapCatalogClientsListDtoToModel } from './mappers';
import type { CatalogClient, GetCatalogClientsFilterParams } from './models';

export const getCatalogClientsFilter = async (
  params: GetCatalogClientsFilterParams,
): Promise<GenericResponse<ApiResponse<CatalogClient[]>>> => {
  try {
    const response = await wtClientApi.get<ApiResponse<CatalogClientDto[]>>(
      '/catalog/clients',
      {
        params,
      },
    );

    const mappedResponse: ApiResponse<CatalogClient[]> = {
      ...response.data,
      data: mapCatalogClientsListDtoToModel(response.data.data ?? []),
    };

    return adaptApiToGenericResponse(mappedResponse, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al obtener los datos del cliente',
    );
  }
};
